<script setup>
import { reactive } from "vue";
import ModalCustom from "./ModalCustom.vue";
import UserAutocompleteInput from "./forms/UserAutocompleteInput.vue";
import SimpleLoadingCircle from "./SimpleLoadingCircle.vue";

const props = defineProps({
    resourceType: {
        type: String,
        required: true,
    },
    resourceId: {
        type: [String],
        required: true,
    },
});
const state = reactive({
    isGeneratingShareLink: false,
    isLoading: false,
    isOpen: false,
    isPublic: false,
    link: null,
    members: [],
    token: null,
});

function openModal() {
    console.log("UWU");
    state.isOpen = true;
    state.isGenerating = true;
    axios
        .post("/shared-link/create", {
            resource_type: props.resourceType,
            resource_id: props.resourceId,
        })
        .then((response) => {
            state.isGenerating = false;
            state.link = response.data.link;
            state.members = response.data.data.members.map((member) => member);
            state.token = response.data.data.token;
            state.isPublic = response.data.data.visibility === "public";
        })
        .catch((error) => {
            state.isGenerating = false;
            console.log(error);
        });
}

function copyShareLink() {
    navigator.clipboard.writeText(state.link);
}

async function updateShareVisibility() {
    try {
        state.isLoading = true;
        await axios.post(`/shared-link/update/${state.token}`, {
            visibility: state.isPublic ? "public" : "private",
        });
    } catch (e) {
        console.log(e);
    }
    state.isLoading = false;
}

async function addShareMember(user) {
    try {
        state.isLoading = true;
        const body = {};
        if (typeof user === "string") {
            body.email = user;
        } else {
            body.id = user.id;
        }
        const res = await axios.post(
            `/shared-link/member/${state.token}/add`,
            body
        );
        state.members.push(res.data);
    } catch (e) {
        console.log(e);
    }
    state.memberInput = "";
    state.isLoading = false;
}

async function removeShareMember(index) {
    const removed = state.members.splice(index, 1);
    await axios.post(`/shared-link/member/${state.token}/remove`, {
        id: removed[0].id,
    });
}
</script>

<template>
    <div @click="openModal()" class="cursor-pointer">
        <slot> </slot>
    </div>
    <ModalCustom
        :is-open="state.isOpen"
        @close="state.isOpen = false"
        title="Share Play"
    >
        <div
            class="flex items-center justify-center"
            v-if="state.isGeneratingShareLink"
        >
            <simple-loading-circle />
        </div>
        <div class="flex items-center bg-gray-200 rounded p-2 gap-2" v-else>
            <input
                type="text"
                class="w-full w-max-[240px] bg-transparent outline-none"
                :value="state.link"
                readonly
                @click="$event.target.select()"
            />
            <button
                class="bg-gray-300 rounded p-2"
                @click="copyShareLink"
                title="Copy to clipboard"
            >
                <ion-icon name="copy-outline"></ion-icon>
            </button>
        </div>
        <div class="mt-6">
            <input
                type="checkbox"
                :readonly="state.isLoading"
                v-model="state.isPublic"
                id="share_is_public"
                @change="updateShareVisibility"
            />
            <label for="share_is_public">
                <span class="ml-2">Public</span>
            </label>
            <div class="text-sm text-gray-500">
                Public plays can be viewed by anyone with the link.
            </div>
        </div>
        <div class="mt-6" v-if="!state.isPublic">
            <h4 class="uppercase text-sm font-semibold">Allowed User</h4>
            <div
                class="my-4 flex gap-2 flex-wrap max-w-lg"
                v-if="state.members.length > 0"
            >
                <div
                    v-for="(member, index) in state.members"
                    class="
                        text-sm
                        p-2
                        rounded
                        inline-flex
                        bg-gray-100
                        gap-2
                        items-center
                    "
                >
                    <img
                        :src="member.user?.avatar"
                        :alt="member.user?.name"
                        v-if="member.user?.avatar"
                        class="w-8 h-8 rounded-full aspect-square"
                    />
                    {{ member.user?.name ?? member.email }}
                    <button
                        type="button"
                        class="
                            bg-transparent
                            text-gray-500
                            flex
                            items-center
                            hover:text-gray-700 hover:bg-gray-300
                            p-1
                            rounded-lg
                        "
                        @click="removeShareMember(index)"
                    >
                        <ion-icon name="close-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <div class="flex items-center gap-2 my-4">
                <UserAutocompleteInput
                    v-if="!state.isLoading"
                    @select="addShareMember"
                ></UserAutocompleteInput>
                <simple-loading-circle v-if="state.isLoading" />
            </div>
        </div>
        <div
            v-if="!state.isPublic && state.members.length === 0"
            class="bg-blue-100 text-gray-700 p-2 my-4 text-xs rounded"
        >
            This play can be only viewed by you.
        </div>
    </ModalCustom>
</template>

<style scoped></style>
